import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";

export default function Commitment() {
    return (
        <section
            data-testid="commitment-section"
            className="relative py-16 sm:py-20 bg-[#FAF9F6]"
        >
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="relative rounded-3xl bg-white border-2 border-[#FF5E3A]/30 p-8 sm:p-10 shadow-sm"
                >
                    <div className="absolute -top-4 left-8 inline-flex items-center gap-2 bg-[#FF5E3A] text-white font-bold text-xs sm:text-sm uppercase tracking-wider rounded-full px-4 py-2">
                        <AlertTriangle className="w-4 h-4" /> Please commit
                    </div>
                    <h3 className="font-display font-black text-2xl sm:text-3xl md:text-4xl text-slate-900 leading-tight mt-2">
                        Only say yes if you mean it.
                    </h3>
                    <p className="mt-4 text-slate-700 text-base sm:text-lg leading-relaxed">
                        Due to high demand and limited capacity, we ask
                        attendees to genuinely commit to attending. A{" "}
                        <span className="font-bold text-slate-900">
                            £100 fee per person
                        </span>{" "}
                        may apply for no-shows without sufficient notice.
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
